export const STORAGE_KEYS = {
  CURRENT_USER: 'currentUser',
  AUTH_TOKEN: 'authToken',
  REFRESH_TOKEN: 'refreshToken'
};
